import React from 'react'
import { FaPlus } from 'react-icons/fa';
import { useRouteMatch } from 'react-router-dom';
import PageContainer from '../../../../components/PageContainer';
import FilialList from '../FilialList';

function FilialPage() {
    const match = useRouteMatch();

    const pageActions = [
        { 
            label: 'Novo',
            icon: <FaPlus />,
            color: 'primary',
            type: 'button',
            href: `${match.path}/new`,
        }
    ]

    const title = 'Lista de Unidades';

    return (
        <PageContainer
            title={title}
            actions={pageActions}
        >
            <FilialList />   
        </PageContainer>
    )
}

export default FilialPage
